// src/actions/tagTypes.js

export const ADD_TAG = "ADD_TAG"
export const SET_TAG_FETCHING = "SET_TAG_FETCHING"
export const GET_TAGS = "GET_TAGS"
export const TAG_ERROR = "TAG_ERROR"
export const TAG_RESET = "TAG_RESET"